import React, { useEffect, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import "../../../assets/css/AccordionDemo.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { getBank } from "../../../services/userMasterUser";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { formatDate } from "../../../constants/FormateDate";
import { Dialog } from "primereact/dialog";
import { bankListUpload } from "../../../services/bankListUpload";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

export default function BankList() {

  const navigate = useNavigate();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [fileName, setFileName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [displayBankListUpload, setDisplayBankListUpload] = useState(false);

  const bankCategoryList = [
    { label: "Nationalised Bank", value: "Nationalised bank" },
    { label: "Private Bank", value: "Private Bank" },
    { label: "Financial Institution", value: "Financial Institution" },
    { label: "Small Bank", value: "Small Bank" },
    { label: "Alternative Investment Fund", value: "Alternative Investment Fund" },
  ]

  const onClickBankListUpload = (item) => {
    setDisplayBankListUpload(true);
  };
  const onHideBankListUpload = () => {
    setFileName("");
    setSelectedImage(null);
    setDisplayBankListUpload(false);
  };
  
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    category: { value: null, matchMode: FilterMatchMode.IN },
    createdDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  
  
    const fetchData = () => {
      getBank()
        .then((response) => {
          if (!response.data.error) {
            setProducts(response.data)
          } else {
            errorMessage("Invalid Credentials");
          }
        })
        .catch((err) => {
          errorMessage();
        })
        .finally(() => console.log(false));
    };

  useEffect(() => {
    fetchData()
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    let _filters = { ...filters };
    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const downloadPDF = (data, type) => {
    const doc = new jsPDF("landScape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 50, 15);
    doc.setFontSize(20);
    doc.text("Customer Data", 220, 15);

    doc.autoTable({
      head: [["Name", "Profile", "Auth Person", "Mobile No.", "Email Id"]],
      body: data.map((item) => [
        item.name,
        item.profile,
        item.authorizedPerson,
        item.authorizedPersonMobile,
        item.email,
      ]),
      startY: 25,
      theme: "grid",
      headStyles: {},
      styles: {
        overflow: "linebreak",
        fontSize: 10,
      },
      // columnStyles: {
      //   0: { cellWidth: 60 },
      //   1: { cellWidth: 30 },
      //   2: { cellWidth: 30 },
      //   3: { cellWidth: 30 },
      //   4: { cellWidth: 40 },
      // },
    });

    if (type === "print") {
      // Create blob URL
      const blob = doc.output("blob");
      const blobURL = URL.createObjectURL(blob);

      // Open blob URL in a new window
      const printWindow = window.open(blobURL);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } else {
      doc.save("Customer-data.pdf");
    }
  };

  const handleBankListUpload = (event) => {
    event.preventDefault();
    const fileInput = event.target.querySelector('input[type="file"]');
    const uploadFile = fileInput.files[0];

    if (!uploadFile) {
      console.error("No file selected");
      return;
    }

    bankListUpload( uploadFile)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Bank List Upload Successfully " + Res.message);
          setFileName("");
          setSelectedImage(null);
          fetchData()
          setDisplayBankListUpload(false);
        } else {
          errorMessage("Bank List Upload Failed " + Res.message);
          setFileName("");
          setSelectedImage(null);
          fetchData()
          setDisplayBankListUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Bank List Upload Failed");
        setFileName("");
        setSelectedImage(null);
        fetchData()
        setDisplayBankListUpload(false);
      });
  };

  const handleBankListDownload = () => {
    const link = document.createElement("a");
    link.href = "/upload_banks.xlsx"; // File path inside public folder
    link.download = "upload_banks.xlsx"; // Rename file on download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setFileName(file ? file.name : ""); // Update the file name or clear it if no file is selected

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  const renderDialogBankListUpload = () => (
    <Dialog
      header="Bank List Upload"
      visible={displayBankListUpload}
      onHide={() => onHideBankListUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleBankListUpload}>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                onClick={handleBankListDownload}
                style={{
                  padding: "10px",
                  background: "blue",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Download Sample File
              </button>
            </div>
          </div>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <label for="file-upload" className="custom-file-upload">
                  <i className="pi pi-upload"></i> Choose Bank List File
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              <div>
                <i
                  className="pi pi-file"
                  style={{ color: "blue", fontSize: "40px" }}
                ></i>
                {fileName && (
                  <p
                    style={{
                      alignSelf: "center",
                      fontSize: 14,
                      fontWeight: 600,
                      margin: 10,
                    }}
                  >
                    {fileName}
                  </p>
                )}
              </div>
            </div>
          </div>
          {selectedImage && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/masters")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Bank List
                </h5>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignSelf: "center" }}>
                    <div style={{ alignSelf: "center" }}>
                      <Link
                        to="/user-master/bank/create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                    <div style={{ alignSelf: "center" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          marginRight: 10,
                          marginLeft: 10,
                        }}
                      >
                        <i
                          onClick={() =>
                            onClickBankListUpload(
                              "displayBankListUpload"
                            )
                          }
                          className="pi pi-upload"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>

                      </div>
                    </div>
                    </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                    <InputText
                      type="text"
                      value={globalFilterValue} 
                      onChange={onGlobalFilterChange} 
                      placeholder="Search..."
                       style={{width:"100%"}}
                    />
                  </div>
                  <div className="col-md">
                      <MultiSelect
                        style={{ width: "100%" }}
                        options={bankCategoryList}
                        value={filters.category?.value || null}
                        onChange={(e) => {
                          let _filters = { ...filters };
                          _filters['category'] = {
                            value: e.value,
                            matchMode: FilterMatchMode.IN
                          };
                          setFilters(_filters);
                        }}
                        placeholder="Select Category"
                        showClear
                      />
                    </div>
                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={50}
                      rowsPerPageOptions={[50, 100, 150]}
                      dataKey="id"
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', 'category']}
                      stripedRows 
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="name"
                        header="Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.name)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="category"
                        header="Category"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData?.category)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.status ? "ACTIVE" : "INACTIVE")}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/user-master/bank/edit"}
                            state={rowData}
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>{renderDialogBankListUpload()}</div>
    </main>
  );
}
